// DS: CMPST16
/** A grid for displaying TopicCards. */
import React, { useContext, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { MobileContext } from '../Context';
import { MeasuredCookieType } from '../Measured';
import MeasuredGrid from '../Grid/MeasuredGrid';
import MobileNativeDropdown from '../Dropdown/MobileNativeDropdown';
import { BiLoggerContextProvider, BiEventType } from '../biLogger';
import TopicCard from './TopicCard';
import s from './TopicGrid.scss';
var LARGE_CARD_GAP = parseInt(s['large-card-gap'], 10) || 24;
var SMALL_CARD_GAP = parseInt(s['small-card-gap'], 10) || 16;
var MOBILE_CARD_GAP = parseInt(s['mobile-card-gap'], 10) || 8;
var GAP_BREAKPOINT = parseInt(s['gap-breakpoint'], 10) || 1366;
export var breakpoints = [
    {
        // mobile
        maxWidth: 490,
        // 3 columns, 2 * 8px column gap, 2 * 16px gutters,
        // available space: 375 - 48 = 327 / 3 columns = 109 each
        elementWidth: 109,
        elementHeight: 109,
    },
    {
        // fix for ipad widths or it runs over right side
        maxWidth: 768,
        // 3 columns, 2 * 8px column gap, 2 * 16px gutters,
        elementWidth: 240,
        elementHeight: 240,
    },
    {
        maxWidth: 1024,
        // 4 columns, 3 * 16px column gap, 2 * 40px gutters,
        elementWidth: 224,
        elementHeight: 224,
    },
    {
        maxWidth: 1280,
        // 5 columns, 4 * 16px column gap, 2 * 40px gutters,
        elementWidth: 227,
        elementHeight: 227,
    },
    {
        maxWidth: 1366,
        // 5 columns, 4 * 16px column gap, 2 * 60px gutters,
        elementWidth: 237,
        elementHeight: 237,
    },
    {
        maxWidth: 1920,
        // 7 columns, 6 * 24px column gap, 2 * 60px gutters,
        elementWidth: 237,
        elementHeight: 237,
    },
];
var TopicGrid = function (props) {
    var isMobile = useContext(MobileContext);
    var t = useTranslation().t;
    var screenWidth = props.screenWidth, _a = props.allTopics, allTopics = _a === void 0 ? [] : _a, className = props.className, topicClassName = props.topicClassName, _b = props.withTitle, withTitle = _b === void 0 ? true : _b;
    var spacing = screenWidth > GAP_BREAKPOINT ? LARGE_CARD_GAP : SMALL_CARD_GAP;
    if (isMobile) {
        spacing = MOBILE_CARD_GAP;
    }
    // we need a sorted list for the native select we use
    // for 'View All' on mobile
    var onSelect = useCallback(goToUrl, [allTopics]);
    var topicsAsOptions = allTopics.map(function (_a) {
        var url = _a.url, name = _a.name, itemId = _a.itemId, typeId = _a.typeId;
        return ({
            value: url,
            label: name,
            biData: {
                // used to determine which biData to fire onchange
                _value: url,
                evid: BiEventType.ITEM_CLICK,
                itemid: itemId,
                sectionname: 'topTopicViewAll',
                typeid: typeId,
            },
        });
    });
    topicsAsOptions.sort(function (a, b) { return a.label.localeCompare(b.label); });
    return (React.createElement("ol", { className: classnames(s['grid'], className) },
        React.createElement(BiLoggerContextProvider, { value: { sectionname: 'topicCard' } },
            withTitle && (React.createElement("div", { className: s['top'] },
                React.createElement("h2", { className: s['title'] }, t('topicListPage.allTopics')),
                isMobile && (React.createElement(MobileNativeDropdown, { className: s['mobile-view-all'], title: t('topicListPage.viewAll'), items: topicsAsOptions, onSelect: onSelect })))),
            React.createElement(MeasuredGrid, { breakpoints: breakpoints, elementCount: allTopics.length, cookieType: MeasuredCookieType.BROWSE, spacing: spacing, getElementId: String, renderElement: function (_a) {
                    var width = _a.width, index = _a.index;
                    var topic = allTopics[index];
                    return (React.createElement(TopicCard, { key: topic.name, className: classnames(s['card'], topicClassName), typeId: topic.typeId, itemId: topic.itemId, name: topic.name, url: topic.url, deviations: topic.exampleDeviations, width: width, rank: index }));
                } }))));
};
TopicGrid.displayName = 'TopicGridCMPST16';
export default TopicGrid;
export function goToUrl(url) {
    return typeof window !== 'undefined' && window.location.assign(url);
}
//# sourceMappingURL=TopicGrid.js.map